@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import xyz.malefic.staticsite.components.layouts.NavBarLayout as _xyz_malefic_staticsite_components_layouts_NavBarLayout
import xyz.malefic.staticsite.pages.AboutPage as _xyz_malefic_staticsite_pages_AboutPage
import xyz.malefic.staticsite.pages.HomePage as _xyz_malefic_staticsite_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Static Site Template"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_staticsite_components_layouts_NavBarLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "xyz.malefic.staticsite.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_staticsite_pages_AboutPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("nav-bar", xyz.malefic.staticsite.styles.NavBarStyle)
        ctx.theme.registerStyle("nav-item", xyz.malefic.staticsite.styles.NavItemStyle)
        ctx.theme.registerStyle("inactive-nav-item", xyz.malefic.staticsite.styles.InactiveNavItemStyle)
        ctx.theme.registerStyle("active-nav-item", xyz.malefic.staticsite.styles.ActiveNavItemStyle)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.staticsite.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
